import styled from 'styled-components';
import { OnlineThemeType } from '../../themes/online';
import { ButtonColor } from '../button/Button';

function buttonColor(color: ButtonColor = ButtonColor.light, theme: OnlineThemeType) {
  switch (color) {
    case ButtonColor.dark:
      return {
        color: theme.colors.dark,
      };
    case ButtonColor.primaryLightBlue:
      return {
        color: theme.colors.primaryLightBlue,
      };
    case ButtonColor.alternate:
      return {
        color: theme.colors.sunbitYellow,
      };
    case ButtonColor.neutral:
      return {
        color: theme.colors.grayDark,
      };
    case ButtonColor.default:
    case ButtonColor.light:
    default:
      return {
        color: theme.colors.light,
      };
  }
}

function buttonDisabled(disabled?: boolean) {
  if (disabled) {
    return {
      opacity: 0.6,
    };
  }
  return {};
}

export default styled.button<{ disabled?: boolean; color?: ButtonColor; bold?: boolean }>(({ theme, disabled, color, bold }) => ({
  cursor: 'pointer',
  outline: 'none',
  display: 'inline-flex',
  alignItems: 'center',
  backgroundColor: 'transparent',
  'font-weight': bold ? `${theme.font.weight.bold}` : `${theme.font.weight.light}`,
  border: 'none',
  ...buttonDisabled(disabled),
  ...buttonColor(color, theme),
  '&:focus': { outline: `2px solid ${theme.colors.dark}` },
  ...(disabled && { cursor: 'default' }),
}));
